import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class StylingCheckService {
    private isClassic$ = new Subject();

    constructor() { }

    getClassic() {
        return this.isClassic$;
    }

    setClassic(data: boolean) {
        this.isClassic$.next(data);
    }
}
